const navigateToSignIn = () => {
    window.location.href = process.env.REACT_APP_SITE_URL + 'sign-in/?logout=true'
}

const getNavigationUrl = (url, params, value) => {
    return url.replace(params, value)
}

export default {
    navigateToSignIn,
    getNavigationUrl
}
